import type { Task } from '../data/projectTypes'

/**
 * The single canonical task-detail URL: `/projects/:projectId/tasks/:taskId`.
 * The route renders ONE unified `TaskDetail` for task, run, or exploration ids; the id kind
 * is resolved server-side by the task-detail envelope, never by the URL or a prefix switch. Every link
 * to a task's detail view should go through this helper so there is one source of truth for the route.
 */
export function taskDetailUrl(projectId: string, taskId: string): string {
  return `/projects/${projectId}/tasks/${taskId}`
}

/**
 * Returns the canonical task-detail URL for a queue task that has an associated detail view,
 * or null otherwise.
 */
export function taskDetailPath(task: Task): string | null {
  if (task.test_run_id) return taskDetailUrl(task.project_id, task.test_run_id)
  if (task.exploration_id) return taskDetailUrl(task.project_id, task.exploration_id)
  return null
}
